import * as React from "react";
import { useState, useEffect } from "react";
import slider_0 from "../images/slider_ausgewogen.png";
import slider_1 from "../images/slider_zinsertrag.png";
import slider_2 from "../images/slider_einkommen.png";
import slider_3 from "../images/slider_ausgewogen.png";
import slider_4 from "../images/slider_wachstum.png";
import slider_5 from "../images/slider_kapitalgewinn.png";
import {
  Container,
  Grid,
  Box,
  IconButton,
  Tooltip,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
function BAVRisk(props) {
  const buttons = ["SEHR TIEF", "TIEF", "MODERAT", "HOCH", "SEHR HOCH"];
  const [button, setButton] = useState();
  const [img, setImage] = useState(slider_0);
  const [value, setValue] = useState(
    props.response.value_1 ? props.response.value_1 : 3,
  ); // Initial Moderat anzeigen
  const handleChange = (event, newButton) => {
    var sel = buttons.indexOf(newButton) + 1;
    setButton(newButton);
    setValue(sel);
    var img;
    switch (sel) {
      case 0:
        img = slider_0;
        break;
      case 1:
        img = slider_1;
        break;
      case 2:
        img = slider_2;
        break;
      case 3:
        img = slider_3;
        break;
      case 4:
        img = slider_4;
        break;
      case 5:
        img = slider_5;
        break;
    }
    setImage(img);
    if (typeof props.callback == "function" && event !== null) {
      props.callback(props, sel);
    }
  };
  useEffect(() => {
    var newValue = buttons[value - 1];
    handleChange(null, newValue);
  }, []);

  return (
    <Container style={{ margin: "0px" }}>
      <Container style={{ marginTop: "20px" }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box position="relative" sx={{ display: "inline-block" }}>
              <img src={img} alt={slider_0} style={{ width: "100%" }} />

              <Tooltip title="Die Übersicht basiert auf historischen, repräsentativen Marktdaten der einzelnen Anlageklassen. Die dargestellten Werte beziehen sich auf die jeweilige Anlagestrategie. Die drei Linien stellen eine schlechte (5%-Quantil / rot), eine mittlere (50%-Quantil / gelb) sowie eine gute (95%-Quantil / grün) Wertentwicklung dar. Mit geringer Wahrscheinlichkeit kann die Wertentwicklung auch ausserhalb dieser Linien zu liegen kommen. Vergangene Marktentwicklungen sind keine Garantie für die zukünftige Wertentwicklung. Die tatsächlich erreichten Vermögenswerte können erheblich von den Schätzwerten abweichen.  ">
                <IconButton
                  aria-label="Informationen"
                  size="small"
                  sx={{
                    position: "absolute",
                    // Button relativ zum IMG positionieren:
                    // Da das IMG 85% Breite hat, platzieren wir relativ zur Box-Kante:
                    top: 0,
                    right: `calc(7% + 8px)`, // 15% = Restbreite neben dem Bild
                  }}
                >
                  <InfoOutlinedIcon />
                </IconButton>
              </Tooltip>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <Container maxWidth="lg">
        <ToggleButtonGroup
          color="primary"
          value={button}
          exclusive
          onChange={handleChange}
          aria-label="Platform"
          size="medium"
          sx={{ width: "100%", pt: 1 }}
          disabled={props.readOnly}
        >
          {buttons.map((_btn, _index) => (
            <ToggleButton key={_index} value={_btn} sx={{ width: "20%" }}>
              {_btn}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </Container>
    </Container>
  );
}
export default BAVRisk;
